"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = require("@authlance/core/lib/browser/store");
const common_1 = require("@authlance/identity/lib/browser/common/common");
const useGroupContext = () => {
    const container = (0, store_1.useAppSelector)((state) => state.app.container);
    return container.get(common_1.GroupContext);
};
exports.default = useGroupContext;
